module.exports = __webpack_public_path__ + "static/boardmember2-min-d9ea9446fd4296f5c1946e0025a791a3.jpg";